import Parse from "parse";

Parse.initialize(
  "iSAfLB3Yu649eDt2gvCbJg9LHU7RbsYhzpdzMLSR",
  "cXuIq8tOiwtopr2fNcEGkpBcnf21kPOLwF5bRqUH",
);

Parse.serverURL = "https://parseapi.back4app.com/";

window.Parse = Parse;

export default Parse;
